/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/history-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna a lista de alterações de status com motivo, submotivo, observação, data e usuário responsável, para exibição na aba Histórico do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna o histórico de status de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/history-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
